<template>
  <div>
    <div class="riTop">
      <img src="@/assets/image/ico7.svg">
<!--      <img src="@/assets/image/ico8.svg">-->
    </div>
    <div style="display: flex;align-items: stretch;gap: 20px;margin-top: 20px;flex-wrap: wrap">
      <div class="card">
        <span>院内餐數</span>
        <div class="cardTop">
          <div class="carddiv" @click="setcanType('first')">
          <div class="cardbtn">
            <div>
               <img src="@/assets/image/y7.svg"/>
               <h4>已完成</h4>
            </div>

          </div>
            <div class="top">
            <i></i>
            <div class=" candiv">
              <div>
                <h2>{{ todayObj.in_agency?todayObj.in_agency[1][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.in_agency?todayObj.in_agency[1][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.in_agency?todayObj.in_agency[1][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
          <p>1. 每日下午 2 點前應完成選餐。</p>
          <p>2. 尚未開通選菜或無提供選菜功能之餐別皆默認為已完成選餐。</p>
          </div>
          <div class="carddiv" @click="setcanType('first')">
            <div class="cardbtn">
              <div>
                <img src="@/assets/image/y8.svg"/>
                <h4>未完成</h4>
              </div>
            </div>
            <div class="top">
              <i></i>
              <div class=" candiv">
                <div>
                  <h2>{{ todayObj.in_agency?todayObj.in_agency[2][1]:'' }}</h2>
                  <span>早餐</span>
                </div>
                <div>
                  <h2>{{ todayObj.in_agency?todayObj.in_agency[2][2]:'' }}</h2>
                  <span>午餐</span>
                </div>
                <div>
                  <h2>{{ todayObj.in_agency?todayObj.in_agency[2][3]:'' }}</h2>
                  <span>晚餐</span>
                </div>
              </div>
            </div>
            <p>每日下午 2 點前未完成選餐
              即默認預設菜單</p>
            <p></p>
          </div>
        </div>
        <div class="cardToptwo">
          <div class="top" @click="setcanType('second')">
            <p>
              <img src="@/assets/image/ico13.svg">
              試吃</p>
            <i></i>
            <div class="bott">
              <div>已完成</div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[1][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[1][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[1][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
            <div class="bott">
              <div>未完成</div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[2][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[2][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3?todayObj.mold_3[2][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
          <div class="top" @click="setcanType('fourth')">
            <p>
              <img src="@/assets/image/ico15.svg">
              陪宿</p>
            <i></i>
            <div class="bott">
              <div>已完成</div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[1][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[1][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[1][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
            <div class="bott">
              <div>未完成</div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[2][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[2][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4?todayObj.mold_4[2][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card cardtwo">
        <span>院外餐數</span>
        <div class="carddiv" @click="setcanType('third')">
          <div class="cardbtn">
            <div>
              <img src="@/assets/image/y7.svg"/>
              <h4>已完成</h4>
            </div>
          </div>
          <div class="top">
            <i></i>
            <div class="candiv">
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[1][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[1][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[1][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
          <p>1. 每日下午 2 點前應完成選餐。</p>
          <p>2. 尚未開通選菜或無提供選菜功能之餐別皆默認為已完成選餐。</p>
        </div>
        <div class="carddiv" @click="setcanType('third')">
          <div class="cardbtn">
            <div>
              <img src="@/assets/image/y8.svg"/>
              <h4>未完成</h4>
            </div>
          </div>
          <div class="top">
            <i></i>
            <div class=" candiv">
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[2][1]:'' }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[2][2]:'' }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_2?todayObj.mold_2[2][3]:'' }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
          <p>每日下午 2 點前未完成選餐
            即默認預設菜單</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tomorrowChooseCount } from "@/api";

export default {
  name: "tomorrow.vue",
  data() {
    return {
      todayObj: {}
    }
  },
  mounted() {
    this.tomorrowChooseCount()
  },
  methods:{
    setcanType(type) {
      this.$emit("done", type);
    },
    tomorrowChooseCount(){
      tomorrowChooseCount().then(res => {
        this.todayObj = res.data.list;
      });
    }
  }
};
</script>



<style scoped lang="scss">
.riTop {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
  cursor: pointer;

  span {
    font-size: 12px;
    color: #DBBD80;
    padding: 0px 6px;
    border: 1px solid #DBBD80;
    border-radius: 5px;
    border-top-width: 8px;
  }

  img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}

.card {
  flex: 2;
  background: #FFFFFF;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 20px;

  span:first-child {
    font-size: 22px;
    display: block;
    text-align: start;
    border-left: 5px solid #DBBD80;
    padding: 0px 10px;
    color: #DBBD80;
  }

  .cardTop {
    display: flex;
    align-items: stretch;
    margin-top: 10px;
    gap: 20px;
    margin-top: 20px;




    .carddiv{
      cursor: pointer;
      flex: 1;
      letter-spacing: 2px;
      border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;
      .cardbtn{
        display: flex;
        align-items: end;
        justify-content: center;
        div{
          flex: 1;
        }
        div:first-child{
          margin: 0 auto;
        }
        h4{
          margin: 0;
          font-size: 26px;
          color: #2c3e50;
          font-weight: bolder !important;
          //border-right: 3px solid #DBBD80;
          margin-bottom: 10px;
        }
        //div:last-child{
        //  font-size: 44px;
        //  color: #DBBD80;
        //  margin: 0;
        //}
      }

      img{
        width: 100px;
        height: 100px;
        object-fit: contain;

      }

      i{
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }
      p{
        font-size: 20px;
        margin:0;
        margin-top: 40px;
      }
       p:last-child{
         margin-top: 0px;
       }
    }
  }


  .cardToptwo{
    margin-top: 20px;
    display: flex;
    gap: 20px;
    .top{
      cursor: pointer;
      flex: 1;
      letter-spacing: 2px;
      border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;
      p{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        img{
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-right: 30px;
        }
      }
      i{
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }
      .bott{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 19px;
        div:first-child{
          font-size: 26px;
          font-weight: bold;
          white-space: nowrap;
        }
        div{
          flex: 1;

          h2{
            font-size: 60px;
            color: #DBBD80;
            margin: 10px;
          }
          span{
            color: #b6b8bd;
          }
        }
      }
    }
  }
}
.cardtwo{
  flex: 1;
  .carddiv{
    cursor: pointer;
    margin-top: 20px;
    letter-spacing: 2px;
    border: 1px solid #FFFFFF;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 38px 50px;
    .cardbtn{
      display: flex;
      align-items: end;
      justify-content: center;
      div{
        flex: 1;
      }
      div:first-child{
        margin: 0 auto;
      }
      h4{
        margin: 0;
        font-size: 26px;
        color: #2c3e50;
        font-weight: bolder !important;
        //border-right: 3px solid #DBBD80;
        margin-bottom: 10px;
      }
      div:last-child{
        font-size: 44px;
        color: #DBBD80;
        margin: 0;
      }
    }

    img{
      width: 100px;
      height: 100px;
      object-fit: contain;

    }

    i{
      display: inline-block;
      width: 30px;
      height: 3px;
      background: #DBBD80;
    }
    p{
      font-size: 20px;
      margin:0;
      margin-top: 40px;
    }
    p:last-child{
      margin-top: 0px;
    }
  }
}
.candiv{
  display: flex;
  div{
    flex: 1;
    h2{
      font-size: 60px;
      color: #DBBD80;
      margin: 10px;
    }
    span{
      color: #b6b8bd;
    }
  }
}

</style>
